import React, { useEffect, useRef, useState } from 'react';
import '../../css/home/Metrics.css';

const Metrics = () => {
  const metricsRef = useRef(null);
  const [counted, setCounted] = useState(false);
  const [metrics, setMetrics] = useState({
    reps: 0,
    reach: 0,
    days: 0,
    students: 0,
  });

  const animateCount = useRef(() => {
    const duration = 2000; // Animation duration in ms
    const steps = 100;

    const increment = (target, metric) => {
      const step = target / steps;
      let current = 0;
      const timer = setInterval(() => {
        current += step;
        if (current >= target) {
          clearInterval(timer);
          setMetrics((prev) => ({
            ...prev,
            [metric]: target,
          }));
          return;
        }
        setMetrics((prev) => ({
          ...prev,
          [metric]: Math.floor(current),
        }));
      }, duration / steps);
    };

    increment(2500, 'reps');
    increment(8, 'reach');
    increment(30, 'days');
    increment(10000, 'students');
  }).current;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !counted) {
          setCounted(true);
          animateCount();
        }
      },
      { threshold: 0.5 }
    );

    const currentRef = metricsRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [counted, animateCount]);

  const metricData = [
    {
      value: `${metrics.reps.toLocaleString()}+`,
      title: 'Onboarded Student Reps',
      subtext: 'Fully vetted, trained, and activated through Romulus.',
    },
    {
      value: `${metrics.reach}M+`,
      title: 'Student Reach',
      subtext: 'Our campaigns connect brands to the heart of college life at scale.',
    },
    {
      value: metrics.days,
      title: 'Day Average Launch Window',
      subtext: 'From kickoff to live, campaigns move quickly with us.',
    },
    {
      value: metrics.students.toLocaleString(),
      title: 'Students Engaged Weekly',
      subtext: 'All real-world, in-person activations: no digital fluff.',
    },
  ];

  return (
    <section className="metrics-section" ref={metricsRef}>
      <h2 className="metrics-title">We Don&apos;t Just Launch Campaigns. We Deliver Results.</h2>
      
      <div className="metrics-grid">
        {metricData.map((metric, index) => (
          <div key={`metric-${index}`} id="results" className="metric-card">
            <div className="metric-number">{metric.value}</div>
            <h3 className="metric-title">{metric.title}</h3>
            <p className="metric-subtext">{metric.subtext}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

Metrics.propTypes = {
  // Add any props validation if needed
};

export default Metrics;